import React, { forwardRef } from 'react';
import { DialogContent, useForkRef, useTheme } from '@mui/material';
import useScrollPagination from '../views/hooks/useScrollPagination';

interface DSDialogContentProps
  extends React.ComponentProps<typeof DialogContent> {
  fetchNextPage?: () => void;
  isFetchingNextPage?: boolean;
  hasNextPage?: boolean;
}
const DSDialogContent = forwardRef<HTMLDivElement, DSDialogContentProps>(
  (props, ref) => {
    const {
      isFetchingNextPage,
      fetchNextPage,
      hasNextPage,
      ...dialogContentProps
    } = props;

    const { spacing, palette } = useTheme();

    const shouldUsePagination =
      fetchNextPage &&
      hasNextPage !== undefined &&
      isFetchingNextPage !== undefined;

    const { scrollRef } = shouldUsePagination
      ? useScrollPagination({
          fetchNextPage: fetchNextPage!,
          isFetchingNextPage: isFetchingNextPage!,
          hasNextPage: hasNextPage!,
        })
      : { scrollRef: null };

    const mergedRef = useForkRef(ref, scrollRef);

    return (
      <DialogContent
        ref={mergedRef}
        {...dialogContentProps}
        sx={{
          '&::-webkit-scrollbar': {
            width: spacing(1),
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: palette.action.selected,
            borderRadius: spacing(8),
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          ...props.sx,
        }}
      />
    );
  },
);

DSDialogContent.displayName = 'DSDialogContent';

export default DSDialogContent;
